import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const Header = styled.header`
  background-color: #ffffff;
  display:flex;
  justify-content: center;
  
`;
export const HeaderWrapper = styled.header`
  background-color: #ffffff;
  box-shadow: 0 2px 1px rgba(0, 0.2, 0, 0.2);
  padding: 16px 0;
  max-width:1440px;
  width:100%;
`;

export const Container = styled.div`
  display:flex;
  justify-content: center;
  
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 30px;
`;

export const LogoContainer = styled(Link)`
  display: flex;
  align-items: center;
`;

export const LogoImage = styled.img`
  width: 150px; /* 기본 너비를 150px로 설정 */
  height: auto; /* 비율에 맞게 높이 자동 조절 */

  @media (max-width: 768px) {
    width: 120px; /* 화면 너비가 768px 이하일 때 너비 조절 */
  }

  @media (max-width: 480px) {
    width: 100px; /* 화면 너비가 480px 이하일 때 너비 조절 */
  }
`;

export const LogoText = styled.span`
  font-size: 18px;
  font-weight: bold;
`;

export const Nav = styled.nav`
  display: flex;
  align-items: center;
`;

export const NavLink = styled(Link)`
  font-size: 18px;
  font-weight: bold; /* Added font-weight property */
  color: #4a5568;
  text-decoration: none;
  padding:0px 10px;
  &:hover {
    color: #1a202c;
  }
`;

export const RightMenu = styled.div`
  display: flex;
  align-items: center;
`;

export const MenuItem = styled(Link)`
  font-size: 18px;
  font-weight: 500;
  color: #4a5568;
  text-decoration: none;
  margin-left: 16px;
  display: flex;
  align-items: center;

  &:hover {
    color: #1a202c;
  }
`;

export const LogoutLabel = styled.label`
  font-size: 18px;
  font-weight: 500;
  color: #4a5568;
  margin-left: 16px;
  cursor: pointer;

  &:hover {
    color: #1a202c;
  }
`;

export const Icon = styled(FontAwesomeIcon)`
  margin-right: 8px;
`;
